import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import LuckyDrawPageComponent from "./luckyDraw.page";
import {AccessRights} from "lib/constants/accessRights";
import LoadingComponent from "components/loading";
import { getLang } from "app/feature/constants";
import {canAccess} from "../../../profile/redux/selector/profile.selector";

function LuckyDrawPageContainer() {
  const history = useHistory()
  const hasLuckyDrawV2AddEditAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.CampaignV2.LUCKY_DRAW_LIST_WRITE_CREATE_TRADITIONAL_RAFFLE)
  );
  const hasLuckyDrawViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Campaign.LUCKY_DRAW_READ));
  const [activeIndex, setActiveIndex] = useState(0);
  const lang = useSelector(state => state.constant.languages)
  const tabLabels = [getLang(lang, "label.LUCKY_DRAW_LIST")];

  useEffect(() => {
    if (!hasLuckyDrawViewAccessRight) {
      history.push("/admin/dashboard")
    }
  }, [history, hasLuckyDrawViewAccessRight])

  const handleChange = (event, index) => {
    setActiveIndex(index);
  };

  if (!hasLuckyDrawViewAccessRight) return <LoadingComponent />;

  return (
    <LuckyDrawPageComponent
      hasLuckyDrawV2AddEditAccessRight={hasLuckyDrawV2AddEditAccessRight}
      handleChange={handleChange}
      activeIndex={activeIndex}
      tabLabels={tabLabels}
      lang={lang}
    />
  );
}

export default LuckyDrawPageContainer;
